module.exports = __webpack_public_path__ + "img/promotion6.3b1cf86e.png";